angular.module('GlobalHelpersModule').filter "valueOrNeverRecorded", ->
  (input) ->
    input = input or ""

    # isnt '/' is for blood pressure readings in vitals
    if input && (input.length > 0 || parseInt(input) != 0) && (input isnt '/')
      input
    else
      'Never recorded'